<template>
    <div class="page-container">
        <div class="page-inner page-left" v-show="!isEdit">
            <div class="page-box-title title1">
                <span>
                    我的素材库
                </span>
                <div style="float:right;">
                    <el-input v-model="keyword" placeholder="请输入关键词" :suffix-icon="Search" @blur="handleCurrentChange(1)"></el-input>
                </div>
            </div>
            <div class="page-tab">
                <div v-for="item in tabList" :key="item.value" :class="['page-tab-item',tabActive==item.value?'page-tab-item-active':'']" @click="tabChange(item)">{{item.label}}</div>
            </div>
            <div class="history-box">
                <div class="page-inner-box empty" v-if="!tableList.length">
                    <img src="@/assets/img/empty.png" />
                    <div>暂无数据</div>
                </div>
                <template v-else>
                    <div :class="['history-box-item',detailIndex==index?'active':'']" v-for="(item,index) in tableList" :key="item.artiCorrectingId" @click="itemClick(item,index)">
                        <div class="history-box-item-top">
                            <div class="title1">
                                <el-checkbox v-model="item.checked" style="margin-right:5px;" />{{item.title}}</div>
                            <div class="history-box-item-tag">
                                <div :class="[`classType${item.type}`]">{{typeFormat(item.type)}}</div>
                            </div>
                        </div>
                        <div class="history-box-item-inner">
                            {{item.content}}
                        </div>
                        <div class="history-box-item-bottom">
                            <div style="display:flex;">
                                <div class="history-box-bottom-icon">
                                    <el-icon size="14">
                                        <Menu />
                                    </el-icon>
                                    <span>来源：{{item.origin=='01'?'开悟作文':'其他书籍'}}</span>
                                </div>
                                <div class="history-box-bottom-icon" style="margin-left:8px;">
                                    <el-icon size="14">
                                        <StarFilled />
                                    </el-icon>
                                    <span>收藏：{{item.collectNum}}</span>
                                </div>
                            </div>
                            <div class="history-box-bottom-icon">
                                <el-icon size="14">
                                    <Clock />
                                </el-icon>
                                <span>发布：{{item.createTime}}</span>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
            <div style="text-align:center;margin-top:10px;">
                <el-config-provider :locale="zhCn" v-if="pageShow">
                    <el-pagination v-model:current-page="pageInfo.current" v-model:page-size="pageInfo.size" :total="pageInfo.total" :page-sizes="[10, 20, 30, 50]" layout="total, sizes,jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
                </el-config-provider>
            </div>
            <el-row :gutter="20" style="margin-top:10px;">
                <el-col :span="8">
                    <div class="page-box-btn danger" @click="delEvent">删除</div>
                </el-col>
                <el-col :span="16">
                    <div class="page-box-btn warning" @click="isEdit=true">自建素材</div>
                </el-col>
            </el-row>
        </div>
        <div class="page-inner page-right" v-show="!isEdit">
            <div class="page-inner-box empty" v-if="!Object.keys(detailInfo).length">
                <img src="@/assets/img/empty.png" />
                <div>暂无数据</div>
            </div>
            <template v-else>
                <div class="page-box-title2 title1">
                    {{detailInfo.title}}
                    <el-button color="#ef8b25" class="footer-btn1" @click="copyEvent" style="float:right;" v-show="Object.keys(detailInfo).length">复制素材</el-button>
                </div>
                <div class="page-inner-box">
                    {{detailInfo.content}}
                </div>
            </template>
        </div>

        <!-- 编辑 -->
        <template v-if="isEdit">
            <div class="page-inner page-left">
                <div class="page-box-title title1">个人素材</div>
                <div>
                    <el-row :gutter="10" style="margin-top:10px;">
                        <el-col :span="24">
                            <el-input maxlength="50" v-model="formData.title" type="textarea" placeholder="请填写素材标题（必填项）"></el-input>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10" style="margin-top:10px;">
                        <el-col :span="24">
                            <el-input maxlength="5000" v-model="formData.content" type="textarea" :rows="6" placeholder="输入要生成的素材的文本内容"></el-input>
                        </el-col>
                    </el-row>
                    <div class="correct-tip">
                        <span class="activeColor">*提示：</span>
                        <span>所有字段都为必填，请认真填写和选择</span>
                    </div>
                    <el-row :gutter="10" style="margin-top:10px;">
                        <el-col :span="24">
                            <el-select v-model="formData.type" placeholder="请选择类型">
                                <el-option v-for="item in pickerColumns" :key="item.value" :value="item.value" :label="item.label"></el-option>
                            </el-select>
                        </el-col>
                    </el-row>
                </div>
                <div style="margin:20px 0;">
                    <el-row :gutter="20">
                        <el-col :span="16">
                            <el-button style="width:100%" color="#ef8b25" class="footer-btn1" @click="submitEvent">确认保存</el-button>
                        </el-col>
                        <el-col :span="8">
                            <el-button style="width:100%" type="info" class="footer-btn1" @click="backEvent">返回</el-button>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <div class="page-inner page-right">
                <div class="page-box-title2 title1">
                    个人素材生成结果
                    <el-button color="#ef8b25" class="footer-btn1" @click="copyEvent" style="float:right;" v-show="Object.keys(resultInfo).length">复制素材</el-button>
                </div>
                <div class="page-inner-box" v-if="Object.keys(resultInfo).length">
                    {{resultInfo.content}}
                </div>
                <div class="page-inner-box empty" v-if="!Object.keys(resultInfo).length">
                    <img src="@/assets/img/empty.png" />
                    <div>结果将在此处展示！</div>
                </div>
            </div>
        </template>
    </div>
</template>
<script lang="ts" setup>
import clipBoard from "vue-clipboard3"
import { ref, reactive, onMounted, onBeforeUnmount, nextTick } from 'vue';
import { compMaterialStreamingV1, saveSreamResult, getMaterial, materialDel, materialAdd, getMaterialDetail } from "@/api/composition.js"
import { formatterEvent } from "@/utils/common.js"
import { ElMessage, ElMessageBox } from "element-plus";
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import { Search } from '@element-plus/icons-vue'
import { useStore } from "vuex"
const store = useStore();
let { toClipboard } = clipBoard()

// 列表
const isEdit = ref(false)
const tabActive = ref('all')
const keyword = ref('')
const tableList = ref([])
const pageInfo = ref({
    current: 1,
    size: 10,
    total: 10
})
const pageShow = ref(true)
const detailInfo = ref({})
const detailIndex = ref(0)
const tabList = [
    {
        label: '全部',
        value: 'all'
    },
    {
        label: '热门词汇',
        value: '01'
    },
    {
        label: '优秀句式',
        value: '02'
    },
    {
        label: '精彩段落',
        value: '03'
    },
]


function tabChange(item) {
    if (item.value == tabActive.value) return
    tabActive.value = item.value
    handleCurrentChange(1)
}

function getList() {
    const params = {
        current: pageInfo.value.current,
        size: pageInfo.value.size,
        type: tabActive.value == 'all' ? '' : tabActive.value,
        title: keyword.value,
    }
    pageInfo.value.total = 0;
    tableList.value = []
    getMaterial(params).then((res: any) => {
        tableList.value = (res.data.records || []).map(item => {
            return {
                ...item,
                checked: false
            }
        })
        pageInfo.value.total = res.data.total || 0;
        if (tableList.value.length) {
            itemClick(tableList.value[0], 0)
        } else {
            detailInfo.value = {}
            detailIndex.value = 0
        }
    })
}

function typeFormat(val) {
    return formatterEvent(tabList, val)
}

function handleSizeChange(val) {
    pageInfo.value.size = val;
    getList()
}
function handleCurrentChange(val) {
    pageInfo.value.current = val;
    pageShow.value = false;
    getList()
    nextTick(() => {
        pageShow.value = true;
    })
}

function delEvent() {
    const arr = tableList.value.filter(item => {
        return item.checked
    })
    if (!arr.length) {
        return ElMessage.warning('请选择记录')
    }
    ElMessageBox.confirm(
        `确认删除已选记录？`,
        '删除提醒'
    ).then(() => {
        let idList = arr.map(item => {
            return item.id
        })
        materialDel({
            idList
        }).then(res => {
            ElMessage.success('删除成功！')
            handleCurrentChange(1)
        })
    })
}

function itemClick(item, index) {
    detailIndex.value = index
    getMaterialDetail({ type: 1, id: item.id }).then(res => {
        detailInfo.value = res.data;
    })
}

onMounted(() => {
    getList()
})

// 列表




// 编辑
const pickerColumns = [
    {
        label: '热门词汇',
        value: '01'
    },
    {
        label: '优秀句式',
        value: '02'
    },
    {
        label: '精彩段落',
        value: '03'
    },
]

const formData = ref({
    content: '',
    title: '',
    type: ''
})

let resultInfo = ref({})

function submitEvent() {
    const { content = '',
        title = '',
        type = '' } = formData.value;
    if (!title) {
        return ElMessage.warning('请填写素材标题');
    }
    if (!content) {
        return ElMessage.warning('请填写素材内容');
    }
    if (!title) {
        return ElMessage.warning('请选择素材类型');
    }
    materialAdd(formData.value).then(res => {
        if (res.data) {
            ElMessage.success('保存成功！')
            resultInfo.value = res.data;
            handleCurrentChange(1)
        }
    })
}

async function copyEvent() {
    try {
        let text = ''
        let obj = isEdit.value ? resultInfo.value : detailInfo.value
        if (Object.keys(obj).length) {
            text = obj.content
        }
        await toClipboard(text)
        ElMessage.success('复制成功')
    } catch{
        ElMessage.error('复制失败')
    }
}

function backEvent() {
    isEdit.value = false
    resultInfo.value = {}
    formData.value = {
        content: '',
        title: '',
        type: ''
    }
}

// 编辑
</script>
<style lang="scss" scoped>
@import "@/style/variable.scss";
.correct-title {
    font-size: 12px;
    color: $base-text-color;
    line-height: 1.8;
    margin: 20px 0;
}

.page-container {
    .page-box-title {
        line-height: unset;
    }
    .page-inner.page-left {
        background: rgba(255, 255, 255, 0.4);
    }
}

.correct-tip {
    font-size: 12px;
    margin: 10px 0;
    color: #999;
}

.upload-box {
     ::v-deep .el-upload-list--picture-card {
        --el-upload-list-picture-card-size: 120px;
    }
     ::v-deep .el-upload--picture-card {
        --el-upload-picture-card-size: 120px
    }
    .upload-inner {
        text-align: center;
        color: #ccc;
    }
}

.page-tab {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
    width: 100%;
    .page-tab-item {
        flex: 1;
        height: 35px;
        line-height: 35px;
        text-align: center;
        background: #fff;
        border-radius: 6px;
        cursor: pointer;
    }
    .page-tab-item-active {
        background: $base-color;
        color: #fff;
    }
    .page-tab-item+.page-tab-item {
        margin-left: 20px;
    }
}

.history-box {
    height: calc(100% - 190px);
    overflow-y: auto;
    .history-box-item {
        padding: 20px 15px;
        background: #fff;
        border-radius: 10px;
        &.active {
            border: 1px solid $base-color;
        }
        .history-box-item-top {
            display: flex;
            justify-content: space-between;
            border-bottom: 1px solid $base-border-color;
            padding: 0 15px 10px;
            align-items: center;
            .title1 {
                display: flex;
                align-items: center;
            }
        }
        .history-box-item-tag {
            display: flex;
            &>div {
                padding: 3px 8px;
                color: #fff;
                border-radius: 6px;
                font-size: 12px;
            }
            &>div+div {
                margin-left: 8px;
            }
            .classType01 {
                color: #c63848;
                background: linear-gradient(#ffd0db, #fef3f1);
            }

            .classType03 {
                color: #686ecc;
                background: linear-gradient(#dad3ff, #eff1fe);
            }

            .classType02 {
                color: #cb5903;
                background: linear-gradient(#ffd8b9, #ffebe2);
            }
        }
        .history-box-item-inner {
            margin: 10px 15px;
            font-size: 14px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
            text-overflow: ellipsis;
            line-height: 24px;
        }
        .history-box-item-bottom {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px 15px 0;
            color: #666;
            font-size: 12px;
            .history-box-bottom-icon {
                display: flex;
                align-items: center;
                &>i+span {
                    margin-left: 5px;
                }
            }
        }
    }
    .history-box-item+.history-box-item {
        margin-top: 15px;
    }
}

.page-box-btn {
    height: 40px;
    line-height: 40px;
    color: #fff;
    text-align: center;
    border-radius: 8px;
    background: $base-color;
}
</style>
